import {cn} from '@bem-react/classname';

export const cnPromoPageFooter = cn('PromoPageFooter');
